import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { getHistory } from "../../services/portalAluno/history/historyService";
import type { ApplicationState } from "../../store";

export const portalHistoryQueryKey = (idUsuario?: number) => [
  "portal-aluno",
  "historico",
  idUsuario,
];

const useHistory = () => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useQuery({
    enabled: Boolean(idUsuario),
    queryKey: portalHistoryQueryKey(idUsuario),
    queryFn: () => getHistory(),
  });
};

export default useHistory;
